<template>
  <dialog-v2 :show="dialog" :disableSaveBtn="disabledBtnSave" :title="title" max-width="450px" @close="$emit('close')" @save="save">
    <template slot="content">
      <v-layout row wrap>
        <template v-if="!isPaymentType">
          <v-flex xs4>
            <v-text-field
            :disabled="!isInRelease"  
            class="w-100 px-2"
              label="Cant Intentos"
              v-model="form.attemps_g2" 
              v-validate="'required|integer'"
              data-vv-name="attemps_g2" 
              data-vv-scope="filter" 
              data-vv-as="ventana de tiempo grupo bot/ivr"
              color="black" 
              :error-messages="errors.collect('attemps_g2')" />
          </v-flex>
          <v-flex xs4>
            <v-text-field
            :disabled="!isInRelease"  
            class="w-100 px-2"
              label="V Intentos"
              v-model="form.days_off_attemps_g2" 
              v-validate="'required|integer'"
              data-vv-name="days_off_attemps_g2" 
              data-vv-scope="filter" 
              data-vv-as="ventana de tiempo grupo bot/ivr"
              color="black" 
              :error-messages="errors.collect('days_off_attemps_g2')" />
          </v-flex>
          <v-flex xs4>
            <v-text-field 
            class="w-100 px-2"
              label="V contacto"
              v-model="form.days_off_g2" 
              v-validate="'required|integer'"
              data-vv-name="days_off_g2" 
              data-vv-scope="filter" 
              data-vv-as="ventana de tiempo grupo bot/ivr"
              color="black" 
              :error-messages="errors.collect('days_off_g2')" />
          </v-flex>
        </template>
        <v-flex xs12>
          <v-select 
          v-model="form.ivr_template_id" 
          :items="ivrTemplates" 
          item-value="id" item-text="name"  
          data-vv-name="ivrTemplateId" 
          data-vv-scope="ivrTemplate"
          data-vv-as="plantilla"
          :error-messages="errors.collect('ivrTemplate.ivrTemplateId')" 
          label="Nombre" 
          color="black" />
        </v-flex>
        <v-flex v-if="isNewWorkflow" xs12>
          <v-select
            v-model="form.ivr_owner_id"
            :items="phoneOwners"
            class="w-100"
            item-value="id"
            item-text="name"
            label="Tipo de teléfono"
            color="black"
          />
        </v-flex>
      </v-layout>
      <v-layout v-if="!isPaymentType" row wrap>
        <v-flex>
          <v-text-field 
            v-model="form.max_attempts" 
            v-validate="'numeric'" 
            data-vv-name="maxAttempts"
            data-vv-scope="ivrTemplate" 
            data-vv-as="intentos maximos" 
            label="Intentos máximos"
            :error-messages="errors.collect('ivrTemplate.maxAttempts')" 
            color="black" />
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import { setTimeout } from 'timers';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    ivrTemplate: {
      required: false,
    },
    isPaymentType: {
      type: Boolean,
      default: false,
    },
    isInRelease: {
      type: Boolean,
      default: false,
    },
    isNewWorkflow: {
      type: Boolean,
      default: false,
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      ivr_template_id: null,
      max_attempts: 3,
      ivr_owner_id: null,
    };
    return {
      dialog: false,
      ivrTemplates: [],
      form: {
        ...emptyForm,
      },
      phoneOwners: [
        {
          id: 1,
          name: 'Titular',
        },
        {
          id: 2,
          name: 'Tercero',
        },
        {
          id: null,
          name: 'Todos los teléfonos',
        },
      ],
    };
  },
  computed: {
    canSave() {
      if (this.isPaymentType) {
        return this.form.ivr_template_id !== null;
      }
      const attemptsSetted = this.form['max_attempts'] !== null && this.form['max_attempts'] !== "";
      return this.form.ivr_template_id !== null && attemptsSetted;
    },
    title() {
      if (this.isNewWorkflow) {
        return `Ajustes de canal ivr`;
      }
      return 'Seleccione una plantilla';
    },
    disabledBtnSave() {
      return !this.canSave  || this.disabledBtn;
    },
  },
  methods: {
    save() {
      this.$validator.validateAll('ivrTemplate').then((validation) => {
        if (validation) {
          this.form['ivr_max_attempts'] = this.form.max_attempts;
          this.$emit('save', this.form);
          this.$emit('close');
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show && !this.ivrTemplates.length) {
        this.axios.get('ivr_templates?paginate=0&status_id=1').then((response) => {
          this.ivrTemplates = response.data.map(item => ({
            id: item.id,
            name: item.name,
          }));
          this.form = {
            ...this.ivrTemplate,
          };
          this.dialog = true;
        });
      } else if (!this.show) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.$validator.errors.remove('ivrTemplateId', 'ivrTemplate');
          this.$validator.errors.remove('maxAttempts', 'ivrTemplate');
        }, 200);
        this.dialog = false;
      } else {
        this.form = {
          ...this.ivrTemplate,
        };
        this.dialog = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowTree/IvrTemplates.vue